import { BookOpenCheckIcon, FileTextIcon, FolderOpenIcon, LightbulbIcon, ListChecksIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  items?: string[];
  benefit: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: '150 Forensic Science Classroom Activities & Challenges',
    description:
      '150 ready-to-use activity ideas covering forensic science fundamentals, crime scene investigation, fingerprints and impressions, trace evidence, forensic biology and DNA, chemistry and toxicology, pathology and anthropology, digital forensics, evidence analysis, and case reconstruction. Organized by difficulty level and topic.',
    benefit: 'Materials already designed for your classroom: saves hours every quarter.',
    value: 'USD 14',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: 'Forensic Science Assessment Bank',
    description:
      'Comprehensive assessment resources designed to evaluate student learning throughout a forensic science course. Includes:',
    items: [
      'Conceptual assessment questions',
      'Short-answer questions',
      'Evidence interpretation exercises',
      'Scenario-based assessments',
      'Case-based questions',
      'Critical-thinking questions',
      'Applied reasoning exercises',
      'Integrated forensic science assessments',
      'Answer keys',
      'Teacher guidance',
    ],
    benefit: 'Never build an exam from scratch under pressure again.',
    value: 'USD 14',
    icon: ListChecksIcon,
  },
  {
    number: '03',
    title: '100 Forensic Science Case Studies & Problem-Solving Scenarios',
    description:
      'A collection of 100 developed forensic cases involving crime scene evidence, fingerprints and impressions, trace evidence, DNA and biological evidence, chemistry and toxicology, pathology and anthropology, digital evidence, evidence reconstruction, competing hypotheses, and integrated forensic evidence.',
    benefit:
      'Students analyze information, evaluate evidence, identify limitations, compare explanations, and develop defensible conclusions.',
    value: 'USD 14',
    icon: FileTextIcon,
  },
  {
    number: '04',
    title: '50 Forensic Science Classroom Projects & Inquiry Challenges',
    description:
      '50 structured classroom projects that encourage students to investigate forensic topics, analyze problems, develop understanding, make recommendations, and communicate their learning through practical classroom work. Each includes objectives, background information, student challenges, instructions, guiding questions, and assessment criteria.',
    benefit: 'Your students finish the year with real forensic science learning projects.',
    value: 'USD 14',
    icon: LightbulbIcon,
  },
  {
    number: '05',
    title: "Forensic Science Teacher's Dictionary: 200 Essential Concepts Explained",
    description:
      'Comprehensive reference handbook covering 200 essential forensic science concepts designed to help teachers explain vocabulary and concepts clearly. Includes terminology related to:',
    items: [
      'Forensic science fundamentals',
      'Crime scene investigation',
      'Evidence',
      'Fingerprints and impressions',
      'Trace evidence',
      'Forensic biology and DNA',
      'Chemistry and toxicology',
      'Pathology and anthropology',
      'Digital forensics',
      'Evidence analysis and reconstruction',
    ],
    benefit: 'Project it in class and your students instantly understand complex forensic science concepts.',
    value: 'USD 14',
    icon: BookOpenCheckIcon,
    wide: true,
  },
];
